<template>
  <div class="container-box">
    <QS-scroller-box>
      <QS-h3-title>
        <template slot="title">租赁方案详情</template>
        <div class="splitline"></div>
      </QS-h3-title>
      <QS-h4-title title="方案基本信息" />
      <div>
        <column-box-expand
          :list="baseCloumn"
          :source="baseSource"
          :separator="columnSeparator"
        />
      </div>
      <QS-h4-title title="租赁规则配置" />
      <div class="orderConfig">
        <column-box-expand
          :list="configColumn"
          :source="configSource"
          :separator="columnSeparator"
        />
      </div>

      <other-collection-items-detail
        v-if="configSource.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI"
        :dataList.sync="receiveData"
      />

      <template slot="bottomAction">
        <el-button
          v-if="state === 0 && this.judgePermission('editRentPlanConfig')"
          @click="goEditPage"
          type="primary"
          size="small"
        >编辑</el-button>
      </template>
    </QS-scroller-box>
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import {
  getLeasingSchemeConfigDetail,
  getLeasingSchemeConfigRecordList,
} from '@/api/domain/orders'
import { PAY_MODE, PAY_PLANT_TYPE, payModeList, payPlanTypeList, PLANT_AMOUNT_TYPE, RENT_AMOUNT_TYPE } from '@/components/DriverCooperationRules/DriverSettlementConfig/config.js'
import { getSettlementAmountFormula } from '@/components/DriverCooperationRules/DriverSettlementConfig/utils.js'
import { CATEGORY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import SelectOption from '@/store/dict/selectOptionDict'
import { TEMPLATE_STATE_MAP } from '@/store/dict/templateDict'
import { mapGetters } from 'vuex'
import OtherCollectionItemsDetail from '../components/otherCollectionItemsDetailNew'
import { PLAN_TYPE, PLAN_TYPE_TEXT } from '../const'

export default {
  name: 'LeaseSchemeDetail',
  data() {
    const { orderType } = this.$route.query
    return {
      // 阶梯方案数据
      piecewiseConfigList: [],
      id: '',
      state: '',
      oLoading: {
        search: false,
      },
      orderType,
      baseSource: {
        orderTypeName: `${PLAN_TYPE_TEXT[orderType]}订单`,
        id: '',
        name: '',
        stateName: '',
        gmtCreate: '',
        templateName: '',
        modelName: '',
        introduction: '',
        explanation: '',
        cityNames: '',
        brandName: '',
        seriesName: '',
      },
      baseCloumn: [
        {
          name: '方案ID',
          key: 'id',
          hasItem: [1, 2], // 1-个人租赁方案展示字段 2-企业租赁方案展示字段
        },
        {
          name: '方案状态',
          key: 'stateName',
          hasItem: [1, 2],
        },
        {
          name: '创建时间',
          key: 'gmtCreate',
          hasItem: [1, 2],
        },
        {
          name: '合同模板',
          key: 'templateName',
          hasItem: [1, 2],
        },
        {
          name: '品牌',
          key: 'brandName',
          hasItem: [1, 2],
        },
        {
          name: '车系',
          key: 'seriesName',
          hasItem: [1, 2],
        },
        {
          name: '车型',
          key: 'modelName',
          hasItem: [1, 2],
        },
        {
          name: '订单类型',
          key: 'orderTypeName',
          hasItem: [1, 2],
        },
        {
          name: '方案名称',
          key: 'name',
          hasItem: [1, 2],
        },
        {
          name: '方案所属城市',
          key: 'cityNames',
          hasItem: [1, 2],
        },
      ],
      configColumn: [
        {
          name: '租赁类型',
          key: 'rentCategoryName',
        },
        {
          name: '预计租赁周期',
          key: 'rentPeriodName',
        },
        {
          name: '赠送天数（天）',
          key: 'presentDays',
        },
        {
          name: '结算周期',
          key: 'payMode',
          driverCooperationMode: true,
        },
        {
          name: '结算日期',
          key: 'payDay',
          driverCooperationMode: true,
        },
        {
          name: '租金金额',
          key: 'driverRentAmount',
          driverCooperationMode: true,
        },
        {
          name: '结算模式',
          key: 'payPlanType',
          driverCooperationMode: true,
        },
        {
          name: '结算金额',
          key: 'settlementAmount',
          driverCooperationMode: true,
          tableList: [],
        },
        {
          name: '结算金额',
          key: 'planAmount',
          driverCooperationMode: true,
        },
      ],
      configSource: {
        rentCalculationRules: '自定义',
        payFormName: '分期支付',
        payTypeName: '按月预付',
        billDayName: '31号（按自然月为计租周期）',
        rentPeriodName: '',
        rentAmount: '',
        deposit: '',
        rentCategory: '',
        payMode: '',
        payDay: '--',
        payPlanType: '',
        settlementAmount: '',
        planAmount: '--',
        driverRentAmount: '--',
      },
      lessMonthSource: {
        dailyRuleName: '',
        lastPeriodRuleName: '',
      },
      CATEGORY_CODE_MAP,
      tableData: [],
      receiveData: [],
    }
  },
  components: {
    OtherCollectionItemsDetail,
  },
  computed: {
    // eslint-disable-next-line vue/no-unused-properties
    ...mapGetters(['cityCodeMap']),
    // eslint-disable-next-line vue/no-unused-properties
    isLessMonthShow() {
      return (
        this.receiveData.length > 0 &&
        this.receiveData.some((item) => {
          // “不足月租金计算规则”仅在租金付款方式为“ payMethod 5 月付（自然月）/payMethod 4 月付（满月）”展示
          return (
            item.type === 1 &&
            item.payMethod &&
            (item.payMethod === 4 || item.payMethod === 5)
          )
        })
      )
    },
  },
  mounted() {
    const { orderType = '' } = this.$route.query
    this.orderType = orderType
    if (orderType === PLAN_TYPE.PERSON) {
      this.baseCloumn = this.baseCloumn.filter((i) => i.hasItem.includes(1))
    }
    if (orderType === PLAN_TYPE.ENTER) {
      this.baseCloumn = this.baseCloumn.filter((i) => i.hasItem.includes(2))
    }
    this.id = this.$route.query.id
    if (!this.id) {
      this.$message.error('缺少ID参数')
      return false
    } else {
      this.getDetail()
      this.getList()
    }
  },
  methods: {
    // 编辑获取详情
    getDetail() {
      getLeasingSchemeConfigDetail({
        id: this.id,
      }).then(({ code, data }) => {
        if (code === 1) {
          this.state = data.state
          this.setData(data)
        }
      })
    },
    // 获取上下架记录列表
    getList() {
      this.oLoading.search = true
      getLeasingSchemeConfigRecordList({
        planId: this.id,
      })
        .then(({ code, data }) => {
          if (code === 1) {
            this.tableData = data
          } else {
            this.tableData = []
          }
        })
        .catch(() => {
          this.tableData = []
        })
        .finally(() => {
          this.oLoading.search = false
        })
    },
    // 设置值
    async setData(data) {
      const res = await this.$store.dispatch('getPaymentMethods', {
        type: 'rentCategory',
      })
      const rentCategoryList = res.data
      this.baseSource.id = this.id
      this.baseSource.stateName = !this.validateIsEmptyValue(data.state)
        ? SelectOption.leasingSchemeState[String(data.state)]
        : ''
      this.baseSource.gmtCreate = data.gmtCreate
      this.baseSource.name = data.name
      this.baseSource.modelName = data.modelName
      if (data.templateState === TEMPLATE_STATE_MAP.JIN_YONG) {
        this.baseSource.templateName = `${data.templateName}(禁用)`
      } else {
        this.baseSource.templateName = data.templateName
      }
      this.baseSource.introduction = data.introduction
      this.baseSource.explanation = data.explanation
      this.baseSource.cityNames = data?.cityNames?.toString() || '--'
      this.baseSource.brandName = data?.brandName || '--'
      this.baseSource.seriesName = data?.seriesName || '--'
      // 租赁类别
      this.configSource.rentCategoryName = this.formatEnumeration(
        rentCategoryList,
      )[data.rentCategory]
      this.configSource.rentCategory = data.rentCategory

      // 非司机合作模式过滤司机合作模式字段
      if (data.rentCategory !== CATEGORY_CODE_MAP.SI_JI_HE_ZUO_MO_SHI) {
        this.configColumn = this.configColumn.filter((item) => !item.driverCooperationMode)
      }

      const isValid = !this.validateIsEmptyValue(data.rentPeriod)
      if (data.rentPeriodType === 1) {
        this.configSource.rentPeriodName = isValid ? `${data.rentPeriod}天` : ''
      } else if (data.rentPeriodType === 3) {
        this.configSource.rentPeriodName = isValid
          ? `${data.rentPeriod}个月`
          : ''
      }
      this.configSource.rentAmount =
        data.rentAmount || data.rentAmount === 0 ? data.rentAmount : ''
      this.configSource.deposit =
        data.deposit || data.deposit === 0 ? data.deposit : ''
      this.configSource.billDay = !this.validateIsEmptyValue(data.billDay)
        ? `${data.billDay}`
        : ''
      this.configSource.presentDays = !this.validateIsEmptyValue(
        data.presentDays,
      )
        ? `${data.presentDays}天`
        : ''
      this.receiveData = data.orderPlanFeeList
      this.lessMonthSource.dailyRuleName = !this.validateIsEmptyValue(
        data.dailyRule,
      )
        ? SelectOption.dailyRentRules[String(data.dailyRule)]
        : ''
      // 尾期租金规则展示
      this.lessMonthSource.lastPeriodRuleName =
        SelectOption.lastPeriodRuleList[data.lastPeriodRule]

      const { orderConfig = {} } = data || {}
      const { piecewiseCalculation = {} } = orderConfig || {}
      const { isOpen = 0, piecewiseConfigList = [] } =
        piecewiseCalculation || {}
      this.configSource.isOpen = SelectOption.schemeTypeList[Number(isOpen)]
      // 阶梯配置详情
      this.piecewiseConfigList =
        (isOpen === 1 &&
          piecewiseConfigList.map((item) => {
            return {
              ladderDate: `${item.startMonth}至${item.endMonth}月`,
            }
          })) ||
        []
      // 司机合作模式字段
      this.configSource.payMode = payModeList[data.payPlanFee?.payMode]
      if (data.payPlanFee?.rentAmount) {
        this.configSource.driverRentAmount = data.payPlanFee?.rentAmountType === RENT_AMOUNT_TYPE.DAY ? `每日${data.payPlanFee?.rentAmount}元*当期自然天数` : `${data.payPlanFee?.rentAmount}元`
      }
      if (data.payPlanFee?.payDay) {
        const chineseNumbers = ['一', '二', '三', '四', '五', '六', '日']
        this.configSource.payDay = [3, 12].includes(data.payPlanFee?.payMode) ? `周${chineseNumbers[Number(data.payPlanFee?.payDay) - 1]}` : `${data.payPlanFee?.payDay}号`
      }
      this.configSource.payPlanType = payPlanTypeList[data.payPlanFee?.payPlanType]
      const settlementAmountItem = this.configColumn.find((item) => item.key === 'settlementAmount')

      if (settlementAmountItem) {
        settlementAmountItem.tableList =
        (data.payPlanFee?.commissionList || []).map((item, index) => {
          return {
            dynamicCondition: `${item.startValue}≤当期支付总金额<${item.endValue && index !== data.payPlanFee.commissionList.length - 1 ? item.endValue : '不限'}`,
            settlementAmount: getSettlementAmountFormula({
              baseSalary: item.baseSalary,
              commissionType: data.payPlanFee.commissionType,
              commissionRate: item.commissionRate,
              startValue: item.startValue,
            }),
          }
        })
      }


      // 司机合作模式-结算方式为日结时过滤结算日期
      if (data.payPlanFee?.payMode === PAY_MODE.DAY) {
        this.configColumn = this.configColumn.filter((item) => item.key !== 'payDay')
      }

      // 司机合作模式-结算金额类型为固定金额时过滤动态金额
      if (data.payPlanFee?.payPlanType === PAY_PLANT_TYPE.FIXED) {
        this.configColumn = this.configColumn.filter((item) => item.key !== 'settlementAmount')
        if (data.payPlanFee?.planAmount) {
          this.configSource.planAmount = data.payPlanFee?.planAmountType === PLANT_AMOUNT_TYPE.DAY ? `每日${data.payPlanFee?.planAmount}元*当期自然天数` : `${data.payPlanFee?.planAmount}元`
        }
      } else {
        this.configColumn = this.configColumn.filter((item) => item.key !== 'planAmount')
      }
    },
    // 去编辑页面
    goEditPage() {
      this.$router.push({
        path: '/purchase/leasingSchemeConfig/edit',
        query: {
          id: this.id,
          type: this.orderType,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.container-box {
  ::v-deep .column-box {
    .el-form-item__content {
      .el-input,
      .el-select,
      .el-textarea,
      .el-date-editor {
        width: 300px !important;
      }
    }
  }
  .orderConfig {
    margin-bottom: 10px;
  }
}
</style>
